import type { ReactNode } from "react";

import { Modal } from "@a2z/ui";

/**
 * Thin wrapper around the canonical @a2z/ui Modal — kept as a separate export
 * because CategoriesClient renders its own form footer, so it passes
 * `hideFooter`. The wrapper exists only so the call site stays readable.
 */
export function CategoryModalShell({
  icon,
  title,
  subtitle,
  onClose,
  children,
}: {
  icon: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <Modal
      isOpen
      onClose={onClose}
      size="lg"
      icon={icon}
      title={title}
      subtitle={subtitle}
      hideFooter
    >
      {children}
    </Modal>
  );
}
